import React from 'react';
import { Modal } from 'react-bootstrap';
import { ReactComponent as LockSecureIcon } from '../../../icons/lock-secure.svg';
import './secure-modal.scss';

interface SecureModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  shieldText: string;
  submitLabel: string;
  submittingLabel?: string;
  onSubmit: () => void;
  submitDisabled?: boolean;
  submitting?: boolean;
  cancelLabel?: string;
  onCancel?: () => void;
  footerLeft?: React.ReactNode;
  backdropClassName?: string;
  className?: string;
  children: React.ReactNode;
}

const SecureModal: React.FC<SecureModalProps> = ({
  show,
  onClose,
  title,
  shieldText,
  submitLabel,
  submittingLabel,
  onSubmit,
  submitDisabled,
  submitting,
  cancelLabel,
  onCancel,
  footerLeft,
  backdropClassName,
  className,
  children,
}) => {
  const dialogClassName = ['response-artifact-modal', 'secure-modal', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      fullscreen='sm-down'
      dialogClassName={dialogClassName}
      backdropClassName={backdropClassName}
    >
      <Modal.Body>
        <div className='sm-custom-header'>
          <div className='sm-header-row'>
            <h1>
              <LockSecureIcon className='sm-header-lock' /> {title}
            </h1>
            <button
              className='modal-close-btn'
              onClick={onClose}
              aria-label='Close'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <line x1='18' y1='6' x2='6' y2='18' />
                <line x1='6' y1='6' x2='18' y2='18' />
              </svg>
            </button>
          </div>
          <div className='sm-shield-banner'>
            <span className='sm-shield-text'>{shieldText}</span>
          </div>
        </div>

        {children}
      </Modal.Body>

      <Modal.Footer>
        <div className='sm-footer'>
          <div className='sm-footer-left'>
            {footerLeft}
            {cancelLabel && onCancel && (
              <button
                className='sm-cancel-btn'
                onClick={onCancel}
                disabled={submitting}
              >
                {cancelLabel}
              </button>
            )}
          </div>
          <div className='sm-footer-right'>
            <button
              className='sm-submit-btn'
              onClick={onSubmit}
              disabled={submitDisabled || submitting}
            >
              {submitting && submittingLabel ? submittingLabel : submitLabel}
              <LockSecureIcon />
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SecureModal;
